/* MMA – „Mehr erfahren“ öffnet die vollständige Gewährleistungsmitteilung als natives <dialog>.
   - showModal(): Fokus wandert in den Dialog, Rest der Seite ist inert, Escape schließt.
   - Fokus geht beim Schließen zurück auf „Mehr erfahren“ (auch nach einem Dawn-Re-Render).
   - Escape im Dialog schließt NUR den Dialog, nicht den Warenkorb (Dawn schließt den Drawer bei keyup Escape).
   - Ohne <dialog>-Unterstützung bleibt der Link aktiv und öffnet die offizielle Datei. */
(function () {
  if (window.MmaWarranty) return;

  let opener = null;
  let swallowEscapeKeyup = false;
  const getDialog = () => document.getElementById('MmaWarrantyDialog');

  function open(trigger) {
    const dialog = getDialog();
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    opener = trigger || null;
    if (!dialog.open) dialog.showModal();
    return true;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mma-warranty-open]');
    if (trigger) {
      if (open(trigger)) event.preventDefault();
      return;
    }
    const dialog = getDialog();
    if (!dialog || !dialog.open) return;
    if (event.target.closest('[data-mma-warranty-close]') || event.target === dialog) dialog.close();
  });

  document.addEventListener(
    'cancel',
    (event) => {
      if (event.target && event.target.id === 'MmaWarrantyDialog') swallowEscapeKeyup = true;
    },
    true
  );

  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key === 'Escape' && swallowEscapeKeyup) {
        swallowEscapeKeyup = false;
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (!event.target || event.target.id !== 'MmaWarrantyDialog') return;
      const target =
        (opener && opener.isConnected && opener) ||
        document.querySelector('#CartDrawer [data-mma-warranty-open]') ||
        document.querySelector('#CartDrawer .drawer__inner');
      if (target) target.focus({ preventScroll: true });
      opener = null;
    },
    true
  );

  window.MmaWarranty = { open };
})();
